// packages/sdk/src/engine/EventBus.ts

export type BusEventType = 'open' | 'close' | 'submit' | 'trigger';

export interface BusEvent {
  type: BusEventType;
  payload?: {
    flowId?: string;
    eventName?: string;
  };
}

export type BusListener = (event: BusEvent) => void;

class EventBus {
  private listeners: Set<BusListener> = new Set();

  on(listener: BusListener): () => void {
    this.listeners.add(listener);
    // Returns an unsubscribe function
    return () => this.listeners.delete(listener);
  }

  emit(event: BusEvent): void {
    this.listeners.forEach(listener => listener(event));
  }

  clear(): void {
    this.listeners.clear();
  }
}

// Singleton — one bus per SDK instance
export const eventBus = new EventBus();